export const SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD = 'SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD';
export type SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD = typeof SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD;

export const CHANGE_HEALTH_CARD_NUMBER = 'CHANGE_HEALTH_CARD_NUMBER';
export type CHANGE_HEALTH_CARD_NUMBER = typeof CHANGE_HEALTH_CARD_NUMBER;

export const CHANGE_VERIFICATION_POSTAL_CODE = 'CHANGE_VERIFICATION_POSTAL_CODE';
export type CHANGE_VERIFICATION_POSTAL_CODE = typeof CHANGE_VERIFICATION_POSTAL_CODE;

export const CHANGE_BUTTON_SUBMIT_STATUS = 'CHANGE_BUTTON_SUBMIT_STATUS';
export type CHANGE_BUTTON_SUBMIT_STATUS = typeof CHANGE_BUTTON_SUBMIT_STATUS;

export const INCREMENT_NUMBER_OF_ATTEMPTS = 'INCREMENT_NUMBER_OF_ATTEMPTS';
export type INCREMENT_NUMBER_OF_ATTEMPTS = typeof INCREMENT_NUMBER_OF_ATTEMPTS;

export const TOGGLE_VALIDATION_MESSAGE_VISIBILITY = 'TOGGLE_VALIDATION_MESSAGE_VISIBILITY';
export type TOGGLE_VALIDATION_MESSAGE_VISIBILITY = typeof TOGGLE_VALIDATION_MESSAGE_VISIBILITY;

export const TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL = 'TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL';
export type TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL = typeof TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL;

export const RESET_ACQUIRE_METHODE_DATA = 'RESET_ACQUIRE_METHODE_DATA';
export type RESET_ACQUIRE_METHODE_DATA = typeof RESET_ACQUIRE_METHODE_DATA;

export const CHANGE_MASK_LOCATION = 'CHANGE_MASK_LOCATION';
export type CHANGE_MASK_LOCATION = typeof CHANGE_MASK_LOCATION;


// WEBPACK FOOTER //
// ./src/store/AcquireHealthCardNumber/constants.ts